<template>
    <div ref="DashboardDropdown" class="relative">
        <button 
        type="button" 
        class="rounded-full bg-eblack-200 px-4 py-0.5 mr-2 cursor-pointer"
        @click="closeDropdown()">{{ selectedItem }}</button>

        <div 
        class="z-10 w-32 absolute top-9 right-0  bg-white divide-y divide-gray-100 rounded-md shadow border border-eblack-200"
        :hidden="!showDropdown">
            <div class="w-full flex flex-col gap-4 py-2">
                <ul class="flex flex-col gap-2">
                    <li 
                    class="hover:bg-eblack-200 text-center cursor-pointer" 
                    v-for="(value,index) in values" :key="index"
                    @click="setValue(value)">{{ value }}</li>
                </ul>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        props:['options'],
        name:"DashboardDropdown",
        data(){
            return {
                selectedItem:"",
                showDropdown:false,
                values:[]
            }
        },
        watch:{
            'options':{
                handler(value){
                    if(value.default && value.values){
                        this.selectedItem = value.default;
                        this.values = value.values
                    }
                },
                immediate:true,
                deep:true
            }
        },
        methods:{
            closeDropdown(){
                this.showDropdown = !this.showDropdown
            },
            handleClickOutside(event) {
                if (this.$refs.DashboardDropdown && !this.$refs.DashboardDropdown.contains(event.target)) {
                    this.showDropdown = false;
                }
            },
            handleFilter(){
                this.applyFilter(this.filter)
            },
            setValue(value){
                this.selectedItem = value
                this.closeDropdown()
                this.action()
            },
            action(){
                this.$emit('load-data',this.selectedItem)
            }
        },
        mounted(){
            document.addEventListener("click", this.handleClickOutside);
        },
        beforeUnmount() {
            document.removeEventListener("click", this.handleClickOutside);
        }
    }
</script>

<style lang="scss" scoped>

</style>